import { Controller } from "@hotwired/stimulus"

/**
 * Handles character reference (anchor) image regeneration on the story short preview step.
 */
export default class extends Controller {
  static values = {
    url: String
  }

  async regenerate(event) {
    const button = event.currentTarget
    if (!confirm("Regenerate the character reference image? Existing scene images will remain unchanged.")) return

    button.disabled = true
    const originalHTML = button.innerHTML
    button.innerHTML = `<svg class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Regenerating...`

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        alert(data.error || "Reference regeneration failed")
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch {
      alert("Network error. Please try again.")
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
